export default "__VITE_ASSET__BYG$Z_Aq__"